export default {
  label: {
    agentNo: '代理账号',
    amount: '更新金额',
    beforeAmount: '更新前金额',
    channelName: '通道编码',
    channelType: '通道类型',
    createTime: '交易时间',
    id: '主键id',
    merchatNo: '商户名称',
    merchatOrderNo: '商户订单号',
    transactionType: '交易类型',
    updateAmount: '更新后金额',
    withdrawBack: '提现退回',
    sysMerchatOrderNo: '系统订单号'
  },
  types: [
    {
      label: '充值',
      value: 1
    },
    {
      label: '提现',
      value: 2
    },
    {
      label: '提现退回',
      value: 3
    },
    {
      label: '额度转移',
      value: 4
    },
    {
      label: '钱包转账',
      value: 5
    },
    {
      label: '人工扣款',
      value: 6
    },
    {
      label: '人工充值',
      value: 7
    },
    {
      label: '代理佣金',
      value: 8
    }
  ]
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/walletRecord.js